export default __webpack_public_path__ + "static/media/stepper-orange.f75db3eb.svg";